import { Fragment, useState } from "react";
import * as utils from "common/utils";
import ActionLink from "components/ActionLink";

export default function GhgEmissionsSourceTable({ emissions, gas }) {
    const [expanded, setExpanded] = useState([]);
    const toggleExpanded = (name) => {
        if (expanded.includes(name)) {
            setExpanded(expanded.filter((item) => item !== name));
        } else {
            setExpanded([...expanded, name]);
        }
    };

    if (!emissions || !gas) return null;

    return (
        <table className="u-tbl-fix">
            <thead>
                <tr>
                    <th>{gas.name}</th>
                    <th className="u-textRight">
                        {emissions?.emissionsPerHectare?.unit?.notation}
                        <h4 className="u-mt-0">{utils.numeric.format(emissions?.emissionsPerHectare?.value)}</h4>
                    </th>
                </tr>
            </thead>
            <tbody>
                {emissions?.sources?.map((source) => (
                    <Fragment key={source.name}>
                        <tr className={`Table-tr--${gas.colour.name}`}>
                            <td>
                                {source.subSources ? (
                                    <ActionLink className="u-flex u-flexAlignItemsCenter u-flexJustifyBetween" onClick={() => toggleExpanded(source.name)}>
                                        {source.name}
                                        <i className={`icon icon-arrow-${expanded.includes(source.name) ? "up" : "down"}`}></i>
                                    </ActionLink>
                                ) : (
                                    <> {source.name}</>
                                )}
                            </td>
                            <td className="u-textRight">{utils.numeric.format(source.emissionsPerHectare.value)}</td>
                        </tr>
                        {expanded.includes(source.name) &&
                            source.subSources?.map((subSource, index) => (
                                <tr key={index} className="tr-nested">
                                    <td>{subSource.name}</td>
                                    <td className="u-textRight">{utils.numeric.format(subSource.emissionsPerHectare.value)}</td>
                                </tr>
                            ))}
                    </Fragment>
                ))}
            </tbody>
        </table>
    )
}
